// export const baseURL = 'https://mobileapproutes.testfire.dev/api';
export const baseURL = 'https://mobileapp.bombaygame.com/api';
export const imageURL = 'https://mobileapp.bombaygame.com';
export const downloadAPK =
  'https://play.google.com/store/apps/details?id=com.bombay365';
// export const baseURL = 'http://192.168.31.7:3000/api/';
